import { mq } from '@kvdbil/components';
import { css } from 'styled-components';

export const responsivePadding = css`
  padding: 0.5rem;

  ${mq(null, 'tablet')} {
    padding: 1rem;
  }

  ${mq('tablet')} {
    padding: 0.75rem 1rem 0.5rem;
  }
`;

/**
 * Use this to reverse outer responsive padding when design requires so .
 */

export const fullwidthMargin = css`
  margin: 0 -0.5rem;

  ${mq(null, 'tablet')} {
    margin: 0 -1rem;
  }
`;
